import { useContext } from "react";
import Context from "./context";
import sceneEditorContext from "./sceneEditorContext";

const useScenes = () => {
	const scenes = useContext(Context);
	return scenes;
};

export const useScene3D = () => {
	const scene = useContext(sceneEditorContext);
	return scene;
};

export default useScenes;
